<template>
  <div class="page-report">
    <HeaderMegaposData />
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Hourly Sales by Branch</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :onlySelectMonth="false"
              :totalDaySelect="60"
              @reload-data="getList"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-4"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input type="search" v-model="searchKeyword" />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                          </tr>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <input v-model="columnSearch[0]" />
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input v-model="columnSearch[index + 1]" />
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="filteredRows.length">
                          <tr v-for="(value, key) in filteredRows" :key="key">
                            <td class="text-right text-xss">
                              {{ key + 1 }}
                            </td>
                            <td
                              v-for="(item, index) in headersData"
                              :key="index"
                              class="text-right text-xss"
                            >
                              {{
                                item.field === "date"
                                  ? value?.date
                                  : formatPrice(value?.[item.field])
                              }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else class="no-data">
                          <tr>
                            <td :colspan="headersData.length + 1" class="text-left">
                              No matching records found
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="total-row">
                            <td class="text-right text-xss">TOTAL</td>
                            <td
                              v-for="(item, index) in headersData"
                              :key="'tf-' + index"
                              class="text-right text-xss"
                            >
                              {{ item.field === "date" ? "" : formatPrice(columnTotals[item.field]) }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/hourly-sales-report/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <!-- <input type="hidden" name="branch_id" :value="form.branch_id" /> -->
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import HeaderMegaposData from "./components/HeaderMegaposData.vue";

export default {
  name: "item-sales-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    HeaderMegaposData,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      items: [],
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      tableData: [],
      columnSearch: [],
      searchKeyword: "",
    };
  },
  computed: {
    // The server appends a grand-total as the last element; the visible total
    // now lives in the table footer and is recomputed from the filtered rows,
    // so the body renders only the real data rows.
    dataRows() {
      return this.items && this.items.length
        ? this.items.slice(0, -1)
        : [];
    },
    // Client-side per-column search (the report loads every row, no pagination),
    // so filtering happens here in Vue instead of via DataTables.
    filteredRows() {
      const search = this.columnSearch || [];
      const keyword = String(this.searchKeyword ?? "").trim().toLowerCase();
      const hasColumnSearch = search.some(
        (s) => s !== undefined && s !== null && String(s).trim() !== ""
      );
      if (!hasColumnSearch && !keyword) return this.dataRows;

      const contains = (cell, term) =>
        String(cell ?? "")
          .toLowerCase()
          .includes(String(term).trim().toLowerCase());

      // Displayed text for a data column (Date as-is, hour columns formatted).
      const cellText = (value, header) =>
        header.field === "date"
          ? value?.date
          : this.formatPrice(value?.[header.field]);

      return this.dataRows.filter((value, key) => {
        // Per-column search — Row No column maps to search[0].
        if (search[0] && String(search[0]).trim() !== "") {
          if (!contains(key + 1, search[0])) return false;
        }
        const columnPass = this.headersData.every((header, i) => {
          const term = search[i + 1];
          if (term === undefined || term === null || String(term).trim() === "") {
            return true;
          }
          return contains(cellText(value, header), term);
        });
        if (!columnPass) return false;

        // Global search — match if Row No or any displayed cell contains it.
        if (keyword) {
          const anyMatch =
            String(key + 1).toLowerCase().includes(keyword) ||
            this.headersData.some((header) =>
              String(cellText(value, header) ?? "")
                .toLowerCase()
                .includes(keyword)
            );
          if (!anyMatch) return false;
        }

        return true;
      });
    },
    // Footer totals: sum each hour column over the filtered rows.
    columnTotals() {
      const totals = {};
      this.headersData.forEach((header) => {
        if (header.field === "date") return;
        totals[header.field] = this.filteredRows.reduce((acc, row) => {
          const n = parseFloat(
            String(row?.[header.field] ?? "").replace(/[^0-9.-]/g, "")
          );
          return acc + (isNaN(n) ? 0 : n);
        }, 0);
      });
      return totals;
    },
    headersData() {
      return [
        {
          label: "Date",
          field: "date",
          hasSortBy: true,
        },
        {
          label: "0",
          field: "hour_00",
          hasSortBy: true,
        },
        {
          label: "1",
          field: "hour_01",
          hasSortBy: true,
        },
        {
          label: "2",
          field: "hour_02",
          hasSortBy: true,
        },
        {
          label: "3",
          field: "hour_03",
          hasSortBy: true,
        },
        {
          label: "4",
          field: "hour_04",
          hasSortBy: true,
        },
        {
          label: "5",
          field: "hour_05",
          hasSortBy: true,
        },
        {
          label: "6",
          field: "hour_06",
          hasSortBy: true,
        },
        {
          label: "7",
          field: "hour_07",
          hasSortBy: true,
        },
        {
          label: "8",
          field: "hour_08",
          hasSortBy: true,
        },
        {
          label: "9",
          field: "hour_09",
          hasSortBy: true,
        },
        {
          label: "10",
          field: "hour_10",
          hasSortBy: true,
        },
        {
          label: "11",
          field: "hour_11",
          hasSortBy: true,
        },
        {
          label: "12",
          field: "hour_12",
          hasSortBy: true,
        },
        {
          label: "13",
          field: "hour_13",
          hasSortBy: true,
        },
        {
          label: "14",
          field: "hour_14",
          hasSortBy: true,
        },
        {
          label: "15",
          field: "hour_15",
          hasSortBy: true,
        },
        {
          label: "16",
          field: "hour_16",
          hasSortBy: true,
        },
        {
          label: "17",
          field: "hour_17",
          hasSortBy: true,
        },
        {
          label: "18",
          field: "hour_18",
          hasSortBy: true,
        },
        {
          label: "19",
          field: "hour_19",
          hasSortBy: true,
        },
        {
          label: "20",
          field: "hour_20",
          hasSortBy: true,
        },
        {
          label: "21",
          field: "hour_21",
          hasSortBy: true,
        },
        {
          label: "22",
          field: "hour_22",
          hasSortBy: true,
        },
        {
          label: "23",
          field: "hour_23",
          hasSortBy: true,
        },
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      const num =
        typeof price === "number"
          ? price
          : parseFloat(String(price ?? "").replace(/[^0-9.-]/g, ""));
      return (
        "$ " +
        (isNaN(num) ? 0 : num).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;
      const totalRow = this.items.pop();

      this.items.sort(function (item, item2) {
        if (direction == "asc") {
          if (item[field] > item2[field]) return 1;
          if (item[field] < item2[field]) return -1;
        }

        if (direction == "desc") {
          if (item[field] < item2[field]) return 1;
          if (item[field] > item2[field]) return -1;
        }

        return 0;
      });

      this.items.push(totalRow);
    },

    getList() {
      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        // branch_id: this.form.branch_id,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
      };

      AnalyticsService.hourlySalesReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.items =
              response.data.data.length > 0 ? response.data.data : [];
            // Reset the search inputs for the freshly loaded data.
            this.columnSearch = new Array(this.headersData.length + 1).fill("");
            this.searchKeyword = "";

            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

tr.total-row {
  font-weight: bold;
  color: #222;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

/* Fit the section within the viewport (minus the title bar) so the page itself
   doesn't scroll — the table region handles its own scrolling instead */
.page-header.my-transacions {
  min-height: calc(100vh - 70px) !important;
}

/* Scroll only the table region so the page stays put; cap height to the viewport */
.custom-table {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

/* Separate borders so the grid lines travel with the sticky header/total row */
.custom-table table.dataTable {
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table table.dataTable th,
.custom-table table.dataTable td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.custom-table table.dataTable th:first-child,
.custom-table table.dataTable td:first-child {
  border-left: 1px solid #dee2e6;
}

.custom-table table.dataTable thead tr:first-child th {
  border-top: 1px solid #dee2e6;
}

/* Keep the header (both rows) fixed at the top while scrolling */
.custom-table table.dataTable thead {
  position: sticky;
  top: 0;
  z-index: 3;
}

.custom-table table.dataTable thead th {
  background: #fff;
}

/* Keep the total row fixed at the bottom */
.custom-table table.dataTable tfoot tr.total-row td {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #e9edf2;
  border-top: 1px solid #dee2e6;
}

/* Column search inputs, styled like Item Sales Details by Channel */
.custom-table table.dataTable thead th input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  color: #495057;
  font-weight: normal;
}

.custom-table table.dataTable thead th input:focus {
  outline: none;
  border-color: #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}
/* Empty-state ("No matching records found") cell: keep the same left/right
   grid borders as the data rows (the width-only rules do not render on a
   single colspan cell). */
.custom-table tbody.no-data > tr > td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

</style>
